import { PAYER_SORT_FIELD, PAYER_STATUS } from "../payers-constant";
import { PayersControls } from "./use-payers-controls";
import { usePayerList, usePayerTotalCount } from "./use-payers-api";

export const usePayersData = ({
  pagination,
  sortModel,
  debouncedSearch,
  filters,
  isArchivedView,
  hasActiveFilters,
}: PayersControls) => {
  const sort = sortModel[0];
  const list = usePayerList({
    pagination,
    sortBy: sort?.field ? PAYER_SORT_FIELD[sort.field] : undefined,
    sortDirection: sort?.sort ?? undefined,
    searchString: debouncedSearch,
    active: filters.status ? filters.status === PAYER_STATUS.ACTIVE : undefined,
    payerType: filters.payerType ?? undefined,
    isArchived: isArchivedView,
  });
  const total = usePayerTotalCount(isArchivedView, hasActiveFilters);

  const filteredCount = list.data?.data?.page?.totalElements ?? 0;

  return {
    rows: list.data?.data?.content ?? [],
    filteredCount,
    totalCount: hasActiveFilters ? (total.data ?? 0) : filteredCount,
    isLoading: list.isLoading || list.isFetching,
    isError: list.isError,
  };
};
